import { Link } from "react-router-dom";
import MarketingPage from "./_shared/MarketingPage";
import { Swoosh } from "./_shared/Hero";

export default function Preise() {
  return (
    <MarketingPage
      eyebrow="Information · Preise"
      h1={
        <>
          Was <Swoosh>kostet</Swoosh> eine Biografie bei Vitanara?
        </>
      }
      lead={
        <>
          Eine klassische Ghostwriter-Biografie kostet in Deutschland zwischen{" "}
          <strong>5.000 und 25.000 Euro</strong>. Vitanara beginnt bei{" "}
          <strong>149&nbsp;€</strong> — möglich wird das durch die
          Telefon-Methode und die KI-gestützte Strukturierung. Im laufenden{" "}
          <strong>Friends &amp; Family Beta</strong> ist Vitanara für
          ausgewählte Familien zusätzlich per Code kostenlos.
        </>
      }
      sections={[
        {
          h2: "Drei Pakete, drei Preise",
          body: (
            <p style={{ margin: 0 }}>
              Jedes Paket enthält zwölf wöchentliche Telefongespräche, das
              menschliche Lektorat und ein leinengebundenes Buch. Was darüber
              hinaus dazukommt, entscheidet das Paket:
            </p>
          ),
          bullets: [
            <>
              <strong>Basis · 149&nbsp;€</strong> — PDF-Biografie, privater
              Familien-Podcast, bis zu 3&nbsp;Std. Interview-Zeit, bis zu
              10&nbsp;Fotos im Buch.
            </>,
            <>
              <strong>Premium · 349&nbsp;€</strong> — alles aus Basis plus
              Hörbuch mit professioneller Erzählstimme, bis zu 6&nbsp;Std.
              Interview-Zeit, bis zu 25&nbsp;Fotos.
            </>,
            <>
              <strong>Exklusiv · 699&nbsp;€</strong> — Premium-PDF mit
              Bildbearbeitung, Hörbuch und Podcast in allen Formaten, bis zu
              10&nbsp;Std. Interview-Zeit, bis zu 50&nbsp;Fotos, bevorzugter
              Kundenservice.
            </>,
          ],
        },
        {
          h2: "Aktuell verfügbar: Basis",
          body: (
            <>
              <p style={{ margin: "0 0 12px" }}>
                Während der Beta-Phase ist das <strong>Basis-Paket</strong>{" "}
                buchbar. Premium und Exklusiv folgen ab 1.&nbsp;September&nbsp;2026.
                Wer jetzt mit Basis startet, kann später jederzeit upgraden —
                die bereits erzählten Inhalte bleiben erhalten.
              </p>
              <p style={{ margin: 0, fontStyle: "italic" }}>
                Vollständige Paket-Übersicht und Buchung auf der{" "}
                <Link
                  to="/pakete"
                  style={{ color: "var(--oxblood)", textDecoration: "none" }}
                >
                  Pakete-Seite
                </Link>
                .
              </p>
            </>
          ),
        },
        {
          h2: "Friends & Family — kostenlos für ausgewählte Familien",
          body: (
            <p style={{ margin: 0 }}>
              Im laufenden Friends&nbsp;&amp;&nbsp;Family-Beta vergibt Vitanara
              eine begrenzte Zahl kostenloser Projekte. Wer einen Code erhalten
              hat, gibt ihn beim Buchen ein — der Preis wird auf
              0&nbsp;€&nbsp;gesetzt. Codes sind nicht öffentlich erhältlich und
              werden persönlich vergeben.
            </p>
          ),
        },
        {
          h2: "Warum klassische Biografen so viel teurer sind",
          body: (
            <p style={{ margin: 0 }}>
              Ein klassischer Ghostwriter rechnet Reise, Interview-Zeit,
              Transkriptions-Aufwand, mehrere Korrekturschleifen und das eigene
              Honorar in den Preis ein. Vitanara reduziert vor allem zwei
              Posten: die Reisezeit entfällt — die erzählende Person ruft
              selbst an — und die Transkription sowie die Erststrukturierung
              übernimmt die KI. Das menschliche Lektorat bleibt. Es ist die
              wichtigste Qualitätsstufe und der Grund, warum das Buch sich
              liest wie ein Buch.
            </p>
          ),
        },
        {
          h2: "Was nicht extra kostet",
          body: (
            <p style={{ margin: 0 }}>
              Bei jedem Paket inklusive:
            </p>
          ),
          bullets: [
            "Handgeschriebene Begrüßungskarte an die erzählende Person",
            "Konrad oder Ida als Biograf*in am Telefon",
            "Jederzeit Pause möglich, keine Frist",
            "DSGVO-konform, Server in Frankfurt",
          ],
        },
      ]}
      faqs={[
        {
          q: "Was kostet Vitanara genau?",
          a: "Basis 149 €, Premium 349 €, Exklusiv 699 € — jeweils einmalig, inklusive Buch und Lektorat. In der Beta-Phase ist Basis buchbar, Premium und Exklusiv folgen ab 1. September 2026.",
        },
        {
          q: "Gibt es Ratenzahlung?",
          a: "Ratenzahlung ist auf Anfrage möglich, sobald Premium und Exklusiv regulär starten. Während der Beta gilt der einmalige Preis bei Buchung.",
        },
        {
          q: "Was kostet ein zusätzliches Buchexemplar?",
          a: "Zusätzliche leinengebundene Exemplare sind zum Selbstkostenpreis erhältlich — viele Familien drucken so viele wie es Enkel gibt.",
        },
        {
          q: "Kann ich Vitanara nur als Hörbuch ohne Buch bekommen?",
          a: "Nein. Das leinengebundene Buch ist Kern jedes Projekts. Hörbuch und Podcast sind im Premium- bzw. Exklusiv-Paket enthalten.",
        },
      ]}
      crossLinks={[
        {
          to: "/pakete",
          label: "Alle Pakete im Detail",
          blurb: "Vergleich der drei Pakete mit allen Inhalten und Buchung.",
        },
        {
          to: "/wie-funktioniert-vitanara",
          label: "Wie funktioniert Vitanara?",
          blurb: "Vom ersten Anruf bis zum fertigen Buch — Schritt für Schritt.",
        },
        {
          to: "/biografie-schreiben-lassen",
          label: "Biografie schreiben lassen",
          blurb:
            "Warum Vitanara anders ist als ein klassischer Ghostwriter.",
        },
      ]}
    />
  );
}
